import type {
  CreateResult,
  DeleteResult,
  ListResult,
  ServiceContext,
} from "@prolarus/shared";
import { tryCreate, tryDelete, tryList, toQueryString } from "./_shared";

export interface GroupPermissionRow {
  permission_id: string;
  name: string;
  code: string;
  category: string | null;
  is_system: boolean;
  is_active: boolean;
  assigned_at: string;
}

export interface GroupPermissionAssignment {
  id: string;
  group_id: string;
  permission_id: string;
  company_id: string;
}

export const groupPermissionService = {
  listPermissions(
    groupId: string,
    _companyId: string,
  ): Promise<ListResult<GroupPermissionRow>> {
    return tryList<GroupPermissionRow>(
      `/api/groups/${encodeURIComponent(groupId)}/permissions`,
    );
  },

  addPermission(
    groupId: string,
    permissionId: string,
    _context: ServiceContext,
  ): Promise<CreateResult<GroupPermissionAssignment>> {
    return tryCreate<GroupPermissionAssignment>(
      `/api/groups/${encodeURIComponent(groupId)}/permissions`,
      { permission_id: permissionId },
    );
  },

  removeBulkPermissions(
    groupId: string,
    permissionIds: string[],
    _companyId: string,
  ): Promise<DeleteResult> {
    return tryDelete(
      `/api/groups/${encodeURIComponent(groupId)}/permissions${toQueryString({
        permission_ids: permissionIds.join(","),
      })}`,
    );
  },
};
